import { styled } from '@mui/material';
import { useId } from 'react';
import Box from 'shell/components/Box';
import Text from 'shell/components/Text';

const GroupRoot = styled('fieldset')(() => ({
    minWidth: 0,
    margin: 0,
    padding: 0,
    border: 0,
    display: 'flex',
    flexDirection: 'column',
}));

const CardGrid = styled(Box, {
    shouldForwardProp: (prop) => prop !== '$columns',
})(({ theme, $columns }) => {
    const columns = typeof $columns === 'number' ? { mobile: $columns, tablet: $columns, desktop: $columns } : $columns;

    return {
        display: 'grid',
        gridTemplateColumns: `repeat(${columns.mobile || 1}, minmax(0, 1fr))`,
        gap: theme.spacing(4),
        [theme.breakpoints.up('tablet')]: {
            gridTemplateColumns: `repeat(${columns.tablet || columns.mobile || 1}, minmax(0, 1fr))`,
        },
        [theme.breakpoints.up('desktop')]: {
            gridTemplateColumns: `repeat(${columns.desktop || columns.tablet || columns.mobile || 1}, minmax(0, 1fr))`,
        },
    };
});

const CheckboxCardGroup = ({
    label,
    description,
    error = false,
    helperText,
    columns = { mobile: 1, tablet: 2, desktop: 2 },
    children,
    sx,
    labelSx,
    descriptionSx,
    gridSx,
    helperTextSx,
}) => {
    const descriptionId = useId();
    const helperTextId = useId();
    const describedBy = [description ? descriptionId : null, helperText ? helperTextId : null]
        .filter(Boolean)
        .join(' ');

    return (
        <GroupRoot sx={sx} aria-describedby={describedBy || undefined} aria-invalid={error || undefined}>
            <Text component={'legend'} variant={'p1'} weight={'medium'} sx={labelSx}>
                {label}
            </Text>
            {description && (
                <Text id={descriptionId} sx={descriptionSx}>
                    {description}
                </Text>
            )}
            <CardGrid $columns={columns} sx={gridSx}>
                {children}
            </CardGrid>
            {helperText && (
                <Text
                    id={helperTextId}
                    color={error ? 'error' : 'light'}
                    role={error ? 'alert' : undefined}
                    sx={helperTextSx}
                >
                    {helperText}
                </Text>
            )}
        </GroupRoot>
    );
};

export default CheckboxCardGroup;
